import { LoadingButton } from "@mui/lab";
import { Grid, TextField } from "@mui/material";
import CampaignAddressesMethods from "../../../actions/campaignAddresses";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useTranslation } from "react-i18next";
import { Namespace } from "../../../locales/translations";
import { Address } from "../../../models/Address";
import { AddressReportActions } from "../../../store/reducers/awareness_campaigns/address_report";
import PersonPinCircleRoundedIcon from '@mui/icons-material/PersonPinCircleRounded';
import { useRefreshedUserPosition } from "../../../hooks/geo";
import { usePartnerID } from "../../../hooks/partners";

export default function AddNewAddressForm() {
    const { t } = useTranslation([Namespace.ADDRESSES]);

    const partnerID = usePartnerID();
    const userAddressLoading = useAppSelector((state) => state.awareness_campaign.address_report.userAddressLoading);
    
    const userPosition = useRefreshedUserPosition();

    const dispatch = useAppDispatch();

    const lookupAddress = async () => {
        if (partnerID && userPosition) {
            dispatch(CampaignAddressesMethods.reverseGeocodeAddress(partnerID, userPosition.lat, userPosition.lng));
        }
    }

    const houseNumber = useAppSelector((state) => state.awareness_campaign.address_report.newAddress?.houseNumber);
    const street = useAppSelector((state) => state.awareness_campaign.address_report.newAddress?.street);
    const postalCode = useAppSelector((state) => state.awareness_campaign.address_report.newAddress?.postalCode);
    const city = useAppSelector((state) => state.awareness_campaign.address_report.newAddress?.city);

    const handleFieldChange = (field: keyof Address, value: string) => {
        dispatch(AddressReportActions.updateAddressField({ field, value }));
    }

    return (
        <Grid container spacing={1}>
            <Grid item width={64}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={t('house_number', { ns: Namespace.ADDRESSES }).toString()}
                    value={houseNumber}
                    onChange={(e) => handleFieldChange('houseNumber', e.target.value)}
                />
            </Grid>
            <Grid item width={`calc(100% - 64px)`}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={t('street', { ns: Namespace.ADDRESSES }).toString()}
                    value={street}
                    onChange={(e) => handleFieldChange('street', e.target.value)}
                />
            </Grid>

            <Grid item width={128}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={t('postal_code', { ns: Namespace.ADDRESSES }).toString()}
                    value={postalCode}
                    onChange={(e) => handleFieldChange('postalCode', e.target.value)}
                />
            </Grid>
            <Grid item width={`calc(100% - 128px)`}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={t('city', { ns: Namespace.ADDRESSES }).toString()}
                    value={city}
                    onChange={(e) => handleFieldChange('city', e.target.value)}
                />
            </Grid>

            <Grid item xs={12} display="flex" justifyContent="center" mt={2} >
                <LoadingButton
                    variant="text"
                    loading={userAddressLoading}
                    onClick={lookupAddress}
                    color="secondary"
                    startIcon={<PersonPinCircleRoundedIcon />}
                >
                    {t('use_current_location', { ns: Namespace.ADDRESSES })}
                </LoadingButton>
            </Grid>
        </Grid>
    );
}